import React, { ReactNode } from 'react';
import { Container, Box, BoxProps } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import Wrapper from 'components/CommonUi/Wrapper';
import { useGradientContext } from 'controllers/GradientController/GradientController';
import useMountEffect from 'hooks/useMountEffect';

type PageHeaderProps = BoxProps & {
    gradientBackgroundColor?: string;
    imgUrl?: string;
};

const headerStyles = css({
    position: 'relative',
    paddingBottom: '3xl',

    mdDown: {
        paddingBottom: '2xl',
    },
});

export const PageHeader: React.FC<PageHeaderProps> = ({
    gradientBackgroundColor,
    children,
}) => {
    const { updateGradient } = useGradientContext();

    useMountEffect(() => {
        updateGradient(gradientBackgroundColor);
    });

    return (
        <Box className={headerStyles}>
            <Wrapper>
                <Container>{children}</Container>
            </Wrapper>
        </Box>
    );
};

interface PageBodyProps {
    children: ReactNode;
    className?: string;
}

export const PageBody = React.forwardRef<HTMLDivElement, PageBodyProps>(
    ({ children, className }, ref) => {
        return (
            <Wrapper>
                <Container
                    ref={ref}
                    style={{ scrollMargin: '48px' }}
                    marginBottom="mg"
                >
                    {children}
                </Container>
            </Wrapper>
        );
    },
);
